// Helpers
import { isValidPhoneNumber } from "@/DataPages/context/crm/LeadsContext/helpers";
import { isIndividual } from "../AddEditPopupDialog/helpers";

// Types
import { ICustomerInformation, IDesiredVehicleInformation, IPhone, TCustomerType } from "@/DataPages/context/crm/interfaces";

function createBusiness(
	type: TCustomerType,
	customer: Pick<ICustomerInformation, "firstInputName" | "secondInputName" | "thirdInputName">
) {
	return !isIndividual(type)
		? {
				name: customer.firstInputName,
				contactFirstName: customer.secondInputName,
				contactLastName: customer.thirdInputName,
		  }
		: {
				name: "",
				contactFirstName: "",
				contactLastName: "",
		  };
}

function createIndividual(
	type: TCustomerType,
	customer: Pick<ICustomerInformation, "firstInputName" | "secondInputName" | "thirdInputName">
) {
	return isIndividual(type)
		? {
				firstName: customer.firstInputName,
				middleName: customer.secondInputName,
				lastName: customer.thirdInputName,
		  }
		: {
				firstName: "",
				lastName: "",
				middleName: "",
		  };
}

function createCommunication(
	customer: Pick<
		ICustomerInformation,
		| "emailConsent"
		| "textConsent"
		| "phoneConsent"
		| "preferredContactMethod"
		| "sendTextTo"
		| "sharePersonalInfoConsent"
		| "usePersonalInfoConsent"
	>
) {
	const {
		emailConsent,
		phoneConsent,
		preferredContactMethod,
		sendTextTo,
		sharePersonalInfoConsent,
		textConsent,
		usePersonalInfoConsent,
	} = customer;

	return {
		emailConsent,
		phoneConsent,
		preferredContactMethod,
		sendTextTo,
		sharePersonalInfoConsent,
		textConsent,
		usePersonalInfoConsent,
	};
}

function createPhones(phones: IPhone[]) {
	return phones.filter((phone) => isValidPhoneNumber(phone.number)).map((phone) => ({ type: phone?.type ?? "", number: phone.number }));
}

function createDesiredVehicles(desiredVehicle: IDesiredVehicleInformation["desiredVehicle"]) {
	return desiredVehicle.map(({ type, vin, year, make, model, style, stockNumber }) => ({
		type,
		vin,
		year,
		make,
		model,
		style,
		stockNumber,
	}));
}

function allSalesLeadsWereSuccessfullyCreated(
	prospects: {
		prospectId?: string;
		error?: string;
	}[]
) {
	return prospects.every((prospect) => prospect.prospectId && !prospect.error);
}

export { createBusiness, createIndividual, createCommunication, createPhones, createDesiredVehicles, allSalesLeadsWereSuccessfullyCreated };
